const calendarLocale = {
  weekDays: ["日", "一", "二", "三", "四", "五", "六"],
  months: {
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月"
  },
  year: "年"
};
export {
  calendarLocale
};
//# sourceMappingURL=zh_CN.js.map
